module.exports = __webpack_public_path__ + "img/qkw_chuan.7d59cf89.gif";